<template>
    <div class="wrapper" v-if="joint">
        <div class="rating-text">Jouw joint heeft een <span class="rating" v-html="parseRating(joint.rating)"></span> gekregen{{joint.rating >= 6 ? '!' : '..'}} {{parseRating(joint.rating) == '6,9' ? ';)' : ''}}</div>
        <div class="button" @click="handleButtonClick">Bereken er nog een</div>
    </div>
</template>

<script>
import JSConfetti from 'js-confetti';

export default {
    name: 'RatedJoint',
    data() {
        return {
            apiConnection: null,
            joint: null
        }
    },
    methods: {
        parseRating(rating) {
            return rating.toLocaleString('nl-NL', { minimumFractionDigits: 0, maximumFractionDigits: 1 })
        },
        handleButtonClick() {
            this.$router.push({ name: 'Form' })
        }
    },
    watch: {
        joint: function() {
            if(!this.joint || this.joint.rating < 8) return

            const jsConfetti = new JSConfetti()
            jsConfetti.addConfetti({
                emojis: ['🌿','🎉','🎊'],
                emojiSize: 50,
                confettiNumber: 30,
            })
        }
    },
    created() {
        const { rating } = this.$route.params;
        if(!rating) return
        this.joint = {
            rating
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/variables.scss';

.wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;

    .rating-text {
        text-align: center;
    }

    .button {
        background-color: $weed-green;
        color: #ffffff;
        padding: 4px 14px;
        margin-top: 24px;
        border-radius: 14px;
        font-weight: 600;
        transition: transform .2s ease;
        user-select: none;
    }
    .button:active {
        transform: scale(0.94);
    }
}

</style>